import I18n from "components/materials/I18n";
import classes from "./classes.module.scss";
import NavTabComponent from "./NavTabComponent";
import { useState } from "react";
import { ETypePersonneJuridique } from "common/enums/ClientSheet/ETypePersonneJuridique";
import PhysicalPersonClients from "./tabs/PhysicalPersonClients";
import Corporations from "./tabs/Corporations";
import DropdownButton, { IDropdownButtonOption } from "components/elements/DropdownButton";
import { UserIcon } from "@heroicons/react/24/outline";
import { BuildingOffice2Icon } from "@heroicons/react/24/outline";

type IProps = {
	officeId: string;
	onSelectClient: (clientSheetId: string, type: "physical" | "legal") => void;
	onCreateNewClient: (type: "PP" | "PM", minimal?: boolean) => void;
};

export default function SelectClient(props: IProps) {
	const [clientType, setClientType] = useState<ETypePersonneJuridique>(ETypePersonneJuridique.personne_physique);

	const onSelectClientWithType = (clientSheetId: string) => {
		const type = clientType === ETypePersonneJuridique.personne_physique ? "physical" : "legal";
		props.onSelectClient(clientSheetId, type);
	};

	const tabItems = [
		{
			label: I18n.asset.pages.mo_manual_subscription.client_types.individual,
			onClick: () => setClientType(ETypePersonneJuridique.personne_physique),
		},
		{
			label: I18n.asset.pages.mo_manual_subscription.client_types.corporation,
			onClick: () => setClientType(ETypePersonneJuridique.personne_morale),
		},
	];

	const dropdownOptions: IDropdownButtonOption[] = [
		{
			title: I18n.asset.pages.mo_manual_subscription.create_client.new_physical_person,
			onClick: () => props.onCreateNewClient("PP", false),
			icon: <UserIcon className={classes["icon"]} />,
		},
		{
			title: I18n.asset.pages.mo_manual_subscription.create_client.new_corporation,
			onClick: () => props.onCreateNewClient("PM", false),
			icon: <BuildingOffice2Icon className={classes["icon"]} />,
		},
		{
			title: I18n.asset.pages.mo_manual_subscription.create_client.new_minimal_physical_person,
			onClick: () => props.onCreateNewClient("PP", true),
			icon: <UserIcon className={classes["icon"]} />,
		},
		{
			title: I18n.asset.pages.mo_manual_subscription.create_client.new_minimal_corporation,
			onClick: () => props.onCreateNewClient("PM", true),
			icon: <BuildingOffice2Icon className={classes["icon"]} />,
		},
	];

	return (
		<div className={classes["root"]}>
			<div className={classes["header"]}>
				<NavTabComponent items={tabItems} />
				<DropdownButton options={dropdownOptions} mainTitle={I18n.asset.pages.mo_manual_subscription.create_client.button} />
			</div>
			{clientType === ETypePersonneJuridique.personne_physique && <PhysicalPersonClients officeId={props.officeId} onSelectClient={onSelectClientWithType} />}
			{clientType === ETypePersonneJuridique.personne_morale && <Corporations officeId={props.officeId} onSelectClient={onSelectClientWithType} />}
		</div>
	);
}
